module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_s.d290f48e.png";